<template>
  <section class="p-1">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Funding</div>
        <div>
          <bread-crumb :bread-crumbs="['Funding']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card class="pa-4 ma-3" v-if="selected_Settlement">
        <v-row>
          <v-col sm="12" md="6" lg="4">
            <div class="menu-sec">
              <v-list-item class="d-flex justify-content-between align-items-center">
                <small>Settlement Number</small>
                <b>{{ selected_Settlement.deal_no }}</b>
              </v-list-item>
            </div>
          </v-col>
          <v-col sm="12" md="6" lg="4">
            <div class="menu-sec">
              <v-list-item class="d-flex justify-content-between align-items-center">
                <small>Fund in USD</small>
                <b>{{ selected_Settlement.credit_amount }} USD</b>
              </v-list-item>
            </div>
          </v-col>
          <v-col sm="12" md="6" lg="4" class="">
            <div class="menu-sec d-flex justify-content-between align-items-center">
              Outstanding Amount:
              <h3>{{ selected_Settlement.settle_balance }} USD</h3>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="ma-2">
        <v-card-text>
          <v-row justify="space-between">
            <v-col cols="6" lg="4" xs="12">
              <v-btn
                depressed
                color="primary text-capitalize"
                class="mr-2 action-btn"
                title="New Fund"
                @click="newFundingClick()"
                small
              >
                <v-icon small>mdi-plus</v-icon> New Fund
              </v-btn>
              <v-btn depressed @click="downloadExcelsheet" color="primary" small
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn>
            </v-col>
            <v-col cols="6" lg="4" xs="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                hide-details
                dense
                clearable
                single-line
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="items"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="fund_id"
          show-expand
          :search="search"
          class="py-4"
          dense
        >
          <template v-slot:item.action="{ item }">
            <div class="d-flex">
              <v-icon
                small
                title="Edit"
                color="primary"
                class="mr-2"
                @click="onclickUpdate(item)"
              >
                mdi-content-save-edit-outline
              </v-icon>
              <v-icon
                small
                title="Delete"
                color="primary"
                class="mr-2"
                @click="deleteItem(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row justify="space-between">
                <v-col cols="12" lg="12" xs="12">
                  <v-row justify="space-between">
                    <span class="text-h6 font-weight-light title-lbl"
                      >Additional Info</span
                    >
                    <v-col cols="12" lg="6" xs="12">
                      <div class="menu-sec">
                        <v-list-item class="v-flex">
                          <label>Purchase Date</label>
                          <b>{{ item.fund_date }}</b>
                        </v-list-item>
                        <v-list-item class="v-flex">
                          <label>USD Rate</label>
                          <b>{{ item.dollar_lcy_rate }}</b>
                        </v-list-item>

                        <v-list-item class="v-flex">
                          <label>FCY</label>
                          <b>{{ item.coll_ccy_pay_ccy }}</b>
                        </v-list-item>

                        <!-- <v-list-item class="v-flex">
                          <label>CCY Type</label>
                          <b>{{ item.lcy_ccy }}</b>
                        </v-list-item> -->
                      </div>
                    </v-col>
                    <v-col cols="12" lg="6" xs="12">
                      <div class="menu-sec">
                        <!-- <v-list-item class="d-flex">
                          <label>Bank Charges</label>
                          <b>{{ item.bank_charges }}</b>
                        </v-list-item> -->
                        <!-- <v-list-item class="v-flex">
                          <label>Bank Name</label>
                          <b>{{ item.bank }}</b>
                        </v-list-item> -->
                        <v-list-item class="v-flex">
                          <label>Created by</label>
                          <b>{{ item.created_by }}</b>
                        </v-list-item>
                        <v-list-item class="v-flex">
                          <label>Edited by</label>
                          <b>{{ item.modified_by }}</b>
                        </v-list-item>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
        <!-- delete dialog -->
        <v-dialog persistent v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3">Are you sure you want to delete?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed small color="primary" outlined @click="deleteItemConfirm">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="(dialogDelete = false), (deleteId = null)"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
import alerts from "@/mixins/alerts";

export default {
  name: "Funding",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  watch: {},
  computed: {},
  data() {
    return {
      expanded: [],
      search: "",
      updateTrigger: false,
      dialogDelete: false,
      deleteId: null,
      selected_Settlement: null,
      ppOptions: null,
      loaderOverlay: false,

      headers: [
        {
          value: "fund_id",
          text: "ID",
        },
        {
          value: "payout_partner",
          text: "Payout Partner",
          sortable: false,
        },
        {
          value: "fund_date",
          text: "Purchase Date",
          sortable: false,
        },
        {
          value: "lcy_amount",
          text: "USD Amount",
          sortable: false,
        },
        {
          value: "pp_amount",
          text: "FCY Converted Amount",
          sortable: false,
        },
        {
          value: "funding_number", //  Need to check that
          text: "Reference Number",
          sortable: false,
        },
        {
          value: "bank_poc",
          text: "Partner POC",
          sortable: false,
        },
        {
          value: "coll_ccy_pay_ccy",
          text: "FCY Type",
          sortable: false,
        },
        {
          value: "action",
          text: "Actions",
          sortable: false,
        },
        { text: "", value: "data-table-expand", sortable: false, width: 50 },
      ],
      items: [],
    };
  },
  mounted() {
    if (this.$route.query.settle_id) {
      this.getSelectedSettDtl(this.$route.query.settle_id);
      this.getSelectedSettlemntFunds(this.$route.query.settle_id);
    } else {
      this.getAllFunds();
    }
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.items) {
        this.exportToExcel(this.headers, this.items, "Fundings");
      }
    },

    async getSelectedSettlemntFunds(settlement_id) {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedFundings(settlement_id);
        if (responseData && responseData.data.status_code == 200) {
          this.items = JSON.parse(JSON.stringify(responseData.data.data[0]));
          this.stoploader();
        } else {
          this.showAlertError(responseData.data.message);
          this.loaderOverlay = false;
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    async getSelectedSettDtl(settlement_id) {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedFundSettDeal(settlement_id);
        console.log(responseData, "response");
        if (responseData && responseData.data.status_code == 200) {
          this.selected_Settlement = responseData.data.data[0];
          this.stoploader();
        } else {
          this.loaderOverlay = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    async getAllFunds() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getAllFundings();
        if (responseData && responseData.data.status_code == 200) {
          this.items = JSON.parse(JSON.stringify(responseData.data.data[0]));
          this.stoploader();
        } else {
          this.showAlertError(responseData.data.message);
          this.loaderOverlay = false;
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    onclickUpdate(selectedRow) {
      this.$router.push({
        path: "/Treasury/NewFunding",
        query: { id: selectedRow.fund_id },
      });
    },

    newFundingClick() {
      this.$router.push({
        name: "New Funding",
        query: { settle_id: this.$route.query.settle_id },
      });
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.fund_id;
    },
    async deleteItemConfirm() {
      try {
        const responseData = await treasuryService.deleteFund(this.deleteId);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getSelectedSettlemntFunds(this.$route.query.settle_id);
          this.getSelectedSettDtl(this.$route.query.settle_id);
          this.dialogDelete = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

.title-lbl {
  width: 100%;
  padding: 5px;
  text-align: center;
  font-weight: bold;
  color: $txt;
  border-bottom: 1px solid $txt;
}
.col-p5 {
  padding-right: 5px !important;
  padding-left: 5px !important;
}

.menu-sec {
  margin-top: 0.5rem;
  .v-list-item {
    min-height: 36px;
    label {
      width: 50%;
    }
  }
}
.card-body {
  padding: 0 !important;
}
.card {
  margin-bottom: 1rem !important;
}

.row {
  margin: 5px;
}

.action-div {
  text-align: end;
}
::v-deep .table {
  td {
    vertical-align: middle !important;
  }
}
.form-group {
  margin-bottom: 0;
}
.list-group-item {
  padding: 0;
}
</style>
